












import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { mdiGiftOutline } from '@mdi/js'
import { filterBonus } from '~/assets/filters/bonus'
import ComponentIcon from '~/components/icon/icon.vue'

// Бонусы за покупку в карточке — мягкая плашка цвета темы, как тип цены.
@Component({
  filters: {
    filterBonus,
  },
  components: {
    ComponentIcon,
  },
})
export default class ComponentProductBonus extends Vue {
  @Prop({ type: Number, default: 0 }) readonly value!: number

  private mdiGiftOutline = mdiGiftOutline
}
